import { validate } from 'validate.js';
const PasswordLengthMin = 10;
const NameLengthMin = 2;
const NameLengthMax = 40;
const phoneRegex = /[+]?[0-9]{6,15}/gis;
const PostalCodeLengthMin = 3;
const PostalCodeLengthMax = 20;
const getConstraints = (lang = 'no') => {
    const englishVersion = lang === 'en';
    const NotEmpty = (attribute) => {
        return {
            allowedEmpty: false,
            message: englishVersion ? `${attribute} Cannot be empty` : `${attribute} kan ikke være tomt`,
        };
    };
    const phoneErrorMessage = englishVersion ? 'Not a valid phone number' : 'Ikke gyldig telefonnummer';
    validate.validators.phone = function (value) {
        if (value != null) {
            return value.replace(/ /g, '').match(phoneRegex) ? null : phoneErrorMessage;
        }
        else {
            return phoneErrorMessage;
        }
    };
    return {
        FirstName: {
            presence: NotEmpty('Fornavnet'),
            length: {
                minimum: NameLengthMin,
                maximum: NameLengthMax,
                message: englishVersion ?
                    `Your first name must be between ${NameLengthMin} and ${NameLengthMax} characters long!` :
                    `Fornavnet ditt må være mellom ${NameLengthMin} og ${NameLengthMax} tegn langt!`,
            },
        },
        LastName: {
            presence: NotEmpty('Etternavnet'),
            length: {
                minimum: NameLengthMin,
                maximum: NameLengthMax,
                message: englishVersion ?
                    `Your last name must be between ${NameLengthMin} and ${NameLengthMax} characters long!` :
                    `Etternavnet ditt må være mellom ${NameLengthMin} og ${NameLengthMax} tegn langt!`,
            },
        },
        PhoneNumber: {
            presence: NotEmpty('Mobilnummeret'),
            phone: {
                message: phoneErrorMessage,
            },
        },
        Email: {
            presence: NotEmpty('Eposten'),
            email: {
                message: englishVersion ? 'Email address is not valid' : 'Eposten er ikke gyldig',
            },
        },
        RepeatedEmail: {
            equality: {
                attribute: 'Email',
                message: englishVersion ? 'Email addresses do not match' : 'Epostene er ikke like!',
                comparator: function (v1, v2) {
                    return JSON.stringify(v1.toLowerCase()) == JSON.stringify(v2.toLowerCase());
                },
            },
        },
        StreetName: {
            presence: NotEmpty('Gateadressen'),
            length: {
                minimum: 2,
                message: englishVersion
                    ? 'Street name must be greater than 2 characters'
                    : 'Gateadressen må være lengere enn 2 tegn',
            },
        },
        PostalCode: {
            presence: NotEmpty('Postnummeret'),
            length: {
                minimum: PostalCodeLengthMin,
                maximum: PostalCodeLengthMax,
                message: englishVersion
                    ? `Postal code must be greater than ${PostalCodeLengthMin} and lesser than ${PostalCodeLengthMax} characters`
                    : `Postnummeret ditt må være lengre enn ${PostalCodeLengthMin} og mindre enn ${PostalCodeLengthMax} tegn`,
            },
        },
        PostalCity: {
            presence: NotEmpty('Poststedet'),
            length: {
                minimum: 2,
                message: englishVersion
                    ? 'City/town must be greater than 2 characters'
                    : 'Poststedet må være lengere enn 2 tegn',
            },
        },
        CountryId: {
            presence: NotEmpty('Landet'),
        },
        Password: {
            presence: NotEmpty('Passordet'),
            length: {
                minimum: PasswordLengthMin,
                message: englishVersion
                    ? `Password must be equal to or greater than ${PasswordLengthMin} characters!`
                    : `Passordet må være større enn eller lik ${PasswordLengthMin} tegn!`,
            },
        },
        RepeatedPassword: {
            equality: {
                attribute: 'Password',
                message: englishVersion
                    ? 'Passwords do not match!'
                    : 'Passordene er ikke like!',
            },
        },
    };
};
export { getConstraints };
